<template>
  <question-base-wrapper v-bind="baseWrapperProps">
    <v-menu
      v-model="showPicker"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="auto"
    >
      <template #activator="{ on, attrs }">
        <validation-provider
          v-slot="{ errors, failedRules }"
          :vid="`${stepId}_${questionId}`"
          :name="questionId"
          :rules="fieldValidationRules"
        >
          <qz-text-field
            :value="dateOfInsuranceLabel"
            :hint="hint"
            :label="label"
            :error-messages="getFieldErrors('field', failedRules, errors)"
            :data-test="snakeCase(questionFields.field)"
            :placeholder="dynamicPlaceholder"
            append-icon="mdi-calendar-blank"
            readonly
            persistent-hint
            v-bind="attrs"
            @click:append="showPicker = true"
            v-on="on"
          />
        </validation-provider>
      </template>
      <v-date-picker
        v-model="questionData[questionFields.field]"
        :min="minDate"
        :max="maxDate"
        :show-current="minDate"
        @input="showPicker = false"
      />
    </v-menu>
  </question-base-wrapper>
</template>

<script>
import QuestionBase from './Base';
import QuestionBaseWrapper from './BaseWrapper';
import {
  ExtDate,
  getDateOfInsuranceLabel,
} from '@/helpers/date';

export default {
  name: 'question-base-date-picker',
  extends: QuestionBase,
  components: { QuestionBaseWrapper },
  props: {
    label: {
      type: String,
      default: '',
    },
    hint: {
      type: String,
      default: '',
    },
    min: {
      type: [String, Number, null],
      default: 0,
    },
    max: {
      type: [Number, null],
      default: 0,
    },
  },
  data () {
    return {
      fields: ['field'],
      showPicker: false,
    };
  },
  computed: {
    dateOfInsuranceLabel () {
      return getDateOfInsuranceLabel(this.questionData[this.questionFields.field]);
    },
    minDate () {
      if (typeof this.min === 'string' && this.min.includes('@')) {
        const stepDataFieldKey = this.min.replace(/@/g, '');

        return this.stepData[stepDataFieldKey] || this.getLimitValue(0);
      }
      return this.getLimitValue(this.min);
    },
    maxDate () {
      return this.getLimitValue(this.max, 12, 31);
    },
    today () {
      return this.getToday();
    },
    fieldValidationRules () {
      if (this.validationRules) {
        return this.helpers.parseRules(this.validationRules.field, this);
      }

      return 'required';
    },
    dynamicPlaceholder () {
      return this.optionsConfig?.placeholder || 'Please select a date';
    },
  },
  methods: {
    getLimitValue (operand, staticM = null, staticD = null) {
      const today = this.today;
      const month = staticM !== null ? staticM : today.month;
      const date = staticD !== null ? staticD : today.date;
      return (today.year + operand) + `-${month}-${date}`;
    },
    getToday () {
      const today = new ExtDate();

      return {
        year: today.getFullYear(),
        month: ((v) => v < 10 ? `0${v}` : v)(today.getMonth() + 1),
        date: ((v) => v < 10 ? `0${v}` : v)(today.getDate()),
      };
    },
  },
};
</script>
